module.exports = __webpack_public_path__ + "img/sun.c0e62050.svg";